import { createDeferredI18n } from "#/shared/composables/useI18n";
import fallbackMessages from "#/shared/i18n/frontend.select.json";

const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "select", fallbackMessages });

export { whenI18nReady };

export function customItemTitle(text) {
  return i18n.global.t("add_custom", { text });
}
